export default __webpack_public_path__ + "static/media/pint-house-desktop.d1c6d8eb.jpg";